
export const parseSongInfo = (filename: string) => {
  const parts = filename.split(' - ');
  
  if (parts.length === 2) {
    return {
      artist: parts[0],
      title: parts[1]
    };
  }
  
  return {
    artist: 'Unknown Artist',
    title: filename
  };
};

export const sanitizeFilename = (filename: string): string => {
  // Remove file extension
  const nameWithoutExtension = filename.replace(/\.[^/.]+$/, '');
  
  // Replace spaces with underscores and remove special characters
  return nameWithoutExtension
    .replace(/\s+/g, '_')
    .replace(/[^a-zA-Z0-9_-]/g, '')
    .substring(0, 50); // Limit length to prevent filesystem issues
};

export const getFileExtension = (filename: string): string => {
  const match = filename.match(/\.([^/.]+)$/);
  return match ? `.${match[1]}` : '.m4a';
};
